module.exports = __webpack_public_path__ + "img/public/SiteIcons/mailIcon.svg?f81fe873";